// extracted by mini-css-extract-plugin
export var base = "_4h-0";
export var updateBanner = "_4h-1";